import { render, staticRenderFns } from "./ManagerCleaningDetails.vue?vue&type=template&id=2b7ff2f8&scoped=true&"
import script from "./ManagerCleaningDetails.vue?vue&type=script&lang=js&"
export * from "./ManagerCleaningDetails.vue?vue&type=script&lang=js&"
import style0 from "./ManagerCleaningDetails.vue?vue&type=style&index=0&id=2b7ff2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ff2f8",
  null
  
)

export default component.exports